import React, { Component } from "react"
import { Container, Input, Row, Col, TabContent, TabPane } from "reactstrap"
import ArgyleUserList from "./ArgyleUserList"
import ArgyleNeverConnectedUserList from "./ArgyleNeverConnectedUserList"
import ActiveDriverArgyleAcccountListing from "./ActiveDriverArgyleAcccountListing"
import Select from 'react-select'
import ListingTabs from "../Material/ListingTabs"
const ARGYLE_LISTING_TABS = [
    { id: "#connected", name: "Connected", iconClassName: "fa fa-link" },
    { id: "#neverconnected", name: "Never Connected", iconClassName: "fa fa-unlink" },
    { id: "#activedriverargyleaccounts", name: "Active Drivers Argle Account", iconClassName: "fa fa-car" },
]
class ArgyleUserListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: "",
            tab: "connected",
            searchTerm: "",
            ongoingRefreshStatus: "enabled",
            rendererdTabPanes: [],
            isActive: true
        }
    }

    toggleTab = (tabId) => {
        if (!this.state.rendererdTabPanes.includes(tabId)) {
            this.setState({ rendererdTabPanes: [...this.state.rendererdTabPanes, tabId] })
        }
        this.setState({ tab: tabId })
    }

    componentDidMount() {
        let defaultTab = ARGYLE_LISTING_TABS[0].id
        if (window.location.hash && ARGYLE_LISTING_TABS.map(item => item.id).includes(window.location.hash)) {
            this.setState({ tab: window.location.hash, rendererdTabPanes: [window.location.hash] })
        } else {
            window.location.hash = defaultTab
            this.setState({ tab: defaultTab, rendererdTabPanes: [defaultTab] })
        }
    }
    componentDidUpdate(_, prevState) {
        if (this.state.tab !== prevState.tab) {
            window.location.hash = this.state.tab
        }
    }

    render() {
        return (
            <Container fluid className="bos-listing-container">
                <ListingTabs
                    tabs={ARGYLE_LISTING_TABS}
                    activeTab={this.state.tab}
                    onChange={this.toggleTab}
                />
                <br />

                <TabContent activeTab={this.state.tab}>
                    {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#connected") && <TabPane tabId="#connected">
                        <ArgyleUserList />
                    </TabPane>}
                    {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#neverconnected") && <TabPane tabId="#neverconnected">
                        <>
                            <Row>
                                <Col xs={4}>
                                    <span className="driver-search-filter">
                                        <Input type="text" name="searchTerm" placeholder="Search by phone, email, name or license" onChange={(e) => this.setState({ searchTerm: e.target.value })} />
                                    </span>
                                </Col>
                                <Col xs={4}>
                                    <div className="pt-2">
                                        <span>Active Drivers</span>
                                        <div className="toggle-switch">
                                            <input
                                                type="checkbox"
                                                className="toggle-switch-checkbox"
                                                name={"isActive"}
                                                id={"isActive"}
                                                checked={!this.state.isActive}
                                                onChange={() => this.setState({ isActive: !this.state.isActive })}
                                            />
                                            <label className="toggle-switch-label" htmlFor={"isActive"}>
                                                <span className="toggle-switch-inner" />
                                                <span className="toggle-switch-switch" />
                                            </label>
                                        </div>
                                        <span>All Drivers</span>
                                    </div>
                                </Col>
                            </Row>
                            <br />
                            <ArgyleNeverConnectedUserList searchTerm={this.state.searchTerm} isActive={this.state.isActive} />
                        </>
                    </TabPane>}
                    {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#activedriverargyleaccounts") && <TabPane tabId="#activedriverargyleaccounts">
                        <>
                            <Row>
                                <Col xs={4}>
                                    <span className="driver-search-filter">
                                        <Select
                                            className="bos-custom-select" classNamePrefix="bos-select"
                                            defaultValue={[{ value: "enabled", label: "ENABLED" }]}
                                            options={[{ value: "enabled", label: "ENABLED" }, { value: "disabled", label: "DISABLED" }, { value: "idle", label: "IDLE" }]}
                                            placeholder="Select Title Owner"
                                            onChange={status => this.setState({ ongoingRefreshStatus: status.value })}
                                        />
                                    </span>
                                </Col>
                            </Row>
                            <br />
                            <ActiveDriverArgyleAcccountListing ongoingRefreshStatus={this.state.ongoingRefreshStatus} />
                        </>
                    </TabPane>}
                </TabContent>
            </Container>
        )
    }
}

export default ArgyleUserListContainer
